module.exports.UI_BASENAME = '/partner'
module.exports.BACKEND_BASENAME = '/partner/backend'

module.exports.CONTENTFUL_SPACE = '/qi7cfyhdnbmj'
